// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pointer-cursor {\n    cursor: pointer !important;\n  }", "",{"version":3,"sources":["webpack://./src/Components/WetdogWeatherProducts/WetDogWeatherLayers.css"],"names":[],"mappings":"AAAA;IACI,0BAA0B;EAC5B","sourcesContent":[".pointer-cursor {\n    cursor: pointer !important;\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
